import React, { useEffect, useRef } from "react";

interface DropdownMenuProps {
  actionIsOpen: boolean;
  setActionIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onActionClick: (action: string) => void;
}

const ActionDropdown: React.FC<DropdownMenuProps> = ({
  actionIsOpen,
  setActionIsOpen,
  onActionClick,
}) => {
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  // Handle click outside to close dropdown
  const handleClickOutside = (event: PointerEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setActionIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("pointerdown", handleClickOutside);
    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, []);

  if (!actionIsOpen) return null;

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        id="dropdown-2"
        data-aspect="action-dropdown"
        className="absolute z-10 bg-white divide-y divide-gray-100 rounded-lg shadow-2xl py-2 w-56 mt-2"
        style={{ left: "-126px" }}
      >
        <ul className="px-4 text-md text-gray-700">
          <li>
            <a
              href="#"
              className="flex items-center gap-2 py-2 mt-2"
              onClick={() => onActionClick("pinFlight")}
            >
              <i className="st-thumbpin text-lightgray-150 text-md"></i>
              <p className="text-lightgray-200 text-md">PIN Flight</p>
            </a>
          </li>
          {/* <li>
            <a
              href="#"
              className="flex items-center gap-2 py-2"
              onClick={() => onActionClick("requestUpdate")}
            >
              <i className="st-reload text-lightgray-150 text-md"></i>
              <p className="text-lightgray-200 text-md cursor-pointer">
                Request Update
              </p>
            </a>
          </li>
          <li>
            <a
              href="#"
              className="flex items-center gap-2 py-2"
              onClick={() => onActionClick("enableStatusUpdate")}
            >
              <i className="st-enable text-lightgray-150 text-md"></i>
              <p className="text-lightgray-200 text-md">Enable Status Update</p>
            </a>
          </li> */}
          <li>
            <a
              href="#"
              className="flex items-center gap-2 py-2"
              onClick={() => onActionClick("deleteRequest")}
            >
              <i className="st-delete text-lightgray-150 text-md"></i>
              <p className="text-lightgray-200 text-md">Delete Request</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ActionDropdown;
